<ppt-actions-toolbar
  [reportData]="reportData"
  [currentView]="currentView"
  [recordsCount]="propertiesCount"
  (navRecordNum)="navRecordNum($event)"
  [requiresSelectTempElement]="false"
></ppt-actions-toolbar>

<div class="container">
  <div class="col"></div>
  <div class="navbar">
    <ul class="navigation-list">
      <li *ngIf="property.header?.propertyName" class="navigation-item">
        <a (click)="goToRecord()" class="action-element">
          <u>{{ property.header.propertyName }}</u>
          <p *ngIf="property.header?.propertyAddress">
            <small
              ><u>{{ property.header.propertyAddress }}</u></small
            >
          </p>
        </a>
      </li>
      <li class="navigation-item"><strong l10nTranslate>template.status</strong>{{ property.header?.status }}</li>
      <li class="navigation-item"><strong l10nTranslate>template.completed</strong> {{ property?.year }}</li>
    </ul>
  </div>

  <div class="sidebar">
    <rep-development-pipeline-view-image
      [propertyImages]="property.images"
      [property]="property"
      [reportId]="reportData.reportId"
    >
    </rep-development-pipeline-view-image>
  </div>
  <div class="main-content">
    <h3 class="property-title" l10nTranslate>template.availableAccommodation</h3>
    <div *ngIf="property.availableAccomodations?.floors">
      <mat-table [dataSource]="property.availableAccomodations.floors" class="mat-elevation-z0">
        <ng-container matColumnDef="FLOOR">
          <mat-header-cell *matHeaderCellDef l10nTranslate>template.floor</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.floor }} </mat-cell>
          <mat-footer-cell *matFooterCellDef l10nTranslate>template.total </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="SQM">
          <mat-header-cell *matHeaderCellDef l10nTranslate>template.sqm</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.sqm }} </mat-cell>
          <mat-footer-cell *matFooterCellDef> {{ property.availableAccomodations.totalSqm }} </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="SQFT">
          <mat-header-cell *matHeaderCellDef l10nTranslate>template.sqft</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.sqft }} </mat-cell>
          <mat-footer-cell *matFooterCellDef> {{ property.availableAccomodations.totalSqft }}</mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        <mat-footer-row *matFooterRowDef="displayedColumns"></mat-footer-row>
      </mat-table>
    </div>
    <h3 class="property-title" l10nTranslate>template.terms</h3>

    <div *ngIf="property.terms">
      <ul class="navigation-list">
        <li *ngFor="let term of property.terms" class="list-item">{{ term.key }}: {{ term.value }}</li>
        <li class="list-item" *ngIf="property.terms.length === 0">N/A</li>
      </ul>
    </div>
    <h3 class="property-title" l10nTranslate>template.conditionAndStatus</h3>

    <div *ngIf="property.conditionStatus">
      <ul class="navigation-list">
        <li *ngFor="let status of property.conditionStatus" class="list-item">{{ status }}</li>
        <li class="list-item" *ngIf="property.conditionStatus.length === 0">N/A</li>
      </ul>
    </div>
    <h3 class="property-title" l10nTranslate>template.summarySpecification</h3>
    <div *ngIf="property.summarySpecification">
      <ul class="navigation-list">
        <li *ngFor="let summary of property.summarySpecification" class="list-item">{{ summary }}</li>
        <li class="list-item" *ngIf="property.summarySpecification.length === 0">N/A</li>
      </ul>
    </div>
    <ng-template #noSummary>N/A</ng-template>
    <h3 class="property-title" l10nTranslate>template.tenants</h3>
    <div *ngIf="property.tenants">
      <ul class="navigation-list">
        <li *ngFor="let tenant of property.tenants" class="list-item">
          {{ tenant.key }}: <u>{{ tenant.value }}</u>
        </li>
        <li class="list-item" *ngIf="property.tenants.length === 0">N/A</li>
      </ul>
    </div>
  </div>
</div>
